import axiosInstance from "../../../utils/axios";

const commonPath = "common"
const path = "user/auth"

export const login = async (values) => {
    return await axiosInstance().post(`${path}/login`, values);
}

export const signup = async (values) => {
  return await axiosInstance().post(`${path}/sign-up`, values);
}

export const forgetPassword = async (values) => {
    return await axiosInstance().patch(`${path}/forgot-password`, values);
}

export const otpVerification = async (values) => {
    return await axiosInstance().patch(`${path}/verify-otp`, values);
}

export const resendOtp = async (values) => {
  return await axiosInstance().patch(`${path}/resend-otp`, values);
}

export const googleLogin = async (values) => {
  return await axiosInstance().post(`${path}/google-login`, values);
}


export const appleLogin = async (values) => {
  return await axiosInstance().post(`${path}/apple-login`, values);
}


export const VerifyResetToken = async (reset_token) => {
  return await axiosInstance().get(`${commonPath}/verify-reset-token?reset_token=${reset_token}`);
}

export const ResetPassword = async (values) => {
  return await axiosInstance().patch(`${path}/reset-password`, values);
}





